<template>
    <div class="oldGreyRoundBorder" v-bind:style="{ 'background-image': 'url(' + currentImage + ')' }" ></div>
</template>
<script>
	export default {
		name: 'profileSmallAvatar',
		props: {
            image: String
        },
         data: function() {
        	return {
                currentImage: null
        	}
        },
        created: function() {
            var self = this;
            this.currentImage = this.image;
            this.$bus.$on('changedAvatar', ($event) => {
                this.currentImage = $event;
            });
        },
	}
</script>


// WEBPACK FOOTER //
// ProfileSmallAvatar.vue?3db56fd1